export const BUSINESS = {
  name: "Bhadani Electronics and Home Appliances",
  shortName: "Bhadani Electronics",
  tagline: "Trusted electronics & home appliances store in Fatehpur, Gaya",
  address:
    "Railway Station Fatehpur, Near Devi Asthan, Fatehpur, Gaya, Bihar - 824232",
  gst: "10BZDPB2001B2ZU",
  phone: "+91 9341061693",
  phoneRaw: "9341061693",
  waNumber: "919341061693",
  email: "electronicsbhadani9@gmail.com",
  instagram:
    "https://www.instagram.com/jio_mart_bhadani?igsh=OGM4cm9iNjdjZWIx",
  instagramHandle: "@jio_mart_bhadani",
};

export const BRANDS = [
  "Samsung",
  "LG",
  "Sony",
  "Panasonic",
  "Whirlpool",
  "Haier",
  "Godrej",
  "IFB",
  "Voltas",
  "Blue Star",
  "Daikin",
  "Hitachi",
  "Bajaj",
  "Havells",
  "Philips",
  "Prestige",
];

export const CATEGORIES = [
  {
    key: "tv",
    title: "Televisions",
    blurb: "Smart LED & 4K TVs from top brands",
    image:
      "https://images.unsplash.com/photo-1646861039459-fd9e3aabf3fb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxsaXZpbmclMjByb29tJTIwdHZ8ZW58MHx8fHwxNzgzMTkyOTIzfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    key: "ac",
    title: "Air Conditioners",
    blurb: "Split & Window AC, 3★ to 5★ inverter",
    image:
      "https://images.unsplash.com/photo-1718203862467-c33159fdc504?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxhaXIlMjBjb25kaXRpb25lcnxlbnwwfHx8fDE3ODMxOTI5MjN8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    key: "fridge",
    title: "Refrigerators",
    blurb: "Single door, double door & side-by-side",
    image:
      "https://images.unsplash.com/photo-1721613877687-c9099b698faa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxyZWZyaWdlcmF0b3J8ZW58MHx8fHwxNzgzMTkyOTIzfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    key: "wm",
    title: "Washing Machines",
    blurb: "Top load, front load & semi-automatic",
    image:
      "https://images.unsplash.com/photo-1626806819282-2c1dc01a5e0c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHx3YXNoaW5nJTIwbWFjaGluZXxlbnwwfHx8fDE3ODMxOTI5MjN8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    key: "kitchen",
    title: "Kitchen Appliances",
    blurb: "Mixers, microwaves, chimneys & more",
    image:
      "https://images.unsplash.com/photo-1556911220-bff31c812dba?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxraXRjaGVuJTIwYXBwbGlhbmNlc3xlbnwwfHx8fDE3ODMxOTI5MjN8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    key: "small",
    title: "Small Appliances",
    blurb: "Fans, irons, geysers & heaters",
    image:
      "https://images.unsplash.com/photo-1585771724684-38269d6639fd?auto=format&fit=crop&w=1200&q=80",
  },
  {
    key: "mobile",
    title: "Mobile Accessories",
    blurb: "Chargers, cables, earphones & more",
    image:
      "https://images.unsplash.com/photo-1512499617640-c2f999098c01?auto=format&fit=crop&w=1200&q=80",
  },
  {
    key: "furniture",
    title: "Furniture",
    blurb: "Beds, sofas, wardrobes & dining sets",
    image:
      "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjAzNzl8MHwxfHNlYXJjaHwxfHxmdXJuaXR1cmUlMjBsaXZpbmclMjByb29tfGVufDB8fHx8MTc4MzE5MjkyM3ww&ixlib=rb-4.1.0&q=85",
  },
];

export const LAGAN_ITEMS = [
  "LED Television",
  "Refrigerator",
  "Washing Machine",
  "Ceiling Fan",
  "Mixer Grinder",
  "Induction Cooktop",
  "Iron Press",
  "Almirah (Steel)",
  "Double Bed",
  "Dining Set",
  "Sofa Set",
];
